import {
    GET_NAT_PROFILE,
    GET_NAT_PROFILE_SUCCESS,
    GET_NAT_PROFILE_FAIL,
    NAT_ADD_TRIGGER,
    ADD_NAT_PROFILE,
    ADD_NAT_PROFILE_COMPLETE,
    EDIT_NAT_PROFILE,
    EDIT_NAT_PROFILE_COMPLETE
} from '../../constants/globalProfileConstants/natProfileConstants';

/**
 * Reducer function for managing Nat Profile list state.
 *
 * This reducer handles actions related to fetching Nat Profile data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the Nat Profile list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const natProfileReducer = (state = { natProfileList: {} }, action) => {
    switch (action.type) {
        case GET_NAT_PROFILE:
            return {
                loading: true,
            };
        case GET_NAT_PROFILE_SUCCESS:
            return {
                loading: false,
                natProfileList: action.payload,
            };
        case GET_NAT_PROFILE_FAIL:
            return {
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};
export const natAddTriggerReducer = (state = { natAddTrigger: false }, action) => {
    switch (action.type) {
        case NAT_ADD_TRIGGER:
            return {
                ...state,
                natAddTrigger: action.payload,
            };
        default:
            return state;
    }
};

export const natAddProfileReducer = (
	state = {
		loading: false,
		status: null,
	},
	action,
) => {
	switch (action.type) {
		case ADD_NAT_PROFILE:
			return {
				...state,
				loading: true,
				status: null,
			};

		case ADD_NAT_PROFILE_COMPLETE:
			return {
				...state,
				loading: false,
				status: action.payload?.status ?? null,
			};

		default:
			return state;
	}
};

export const natEditProfileReducer = (
	state = {
		loading: false,
		status: null,
	},
	action,
) => {
	switch (action.type) {
		case EDIT_NAT_PROFILE:
			return {
				...state,
				loading: true,
				status: null,
			};

		case EDIT_NAT_PROFILE_COMPLETE:
			return {
				...state,
				loading: false,
				status: action.payload?.status ?? null,
			};

		default:
			return state;
	}
};
